module.exports = __webpack_public_path__ + "img/part6-icon1-over.fe131902.png";